// extracted by mini-css-extract-plugin
export default {"notified-container":"notified_notified-container__VD7U1"};